/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import InputReactSelect from 'modules/common/components/InputReactSelect';
import * as actions from '../../../action';
import * as c from '../../../constant';
import Garbage from './common/Garbage';
import License from './common/License';
import Permit from './common/Permit';
import Sanitary from './common/Sanitary';

const INIT_STATE = {
  code: '',
  name: '',
  garbage_code: '',
  license_code: '',
  permit_code: '',
  sanitary_code: '',
  other_fees: [],
};

function CreateRangeModal({
  newBusinessNaturesId,
  createNewBusinessLines,
  getNewBusinessLinesList,
  creating,
  ordinanceRevisionId,
  getBusinessLineOtherFeeList,
  businessLineOtherFeeList,
  isOtherFeesLoading,
}) {
  const [formData, setFormData] = useState(INIT_STATE);

  const validateForm = useFormValidator(formData, {
    code: 'required',
    name: 'required',
  });
  const setModal = useContext(ModalContext);

  useEffect(() => {
    if (!ordinanceRevisionId) return;
    getBusinessLineOtherFeeList({ 
      ordinance_revision_id: ordinanceRevisionId,
    });
  }, [ordinanceRevisionId]);

  const otherFeesOptions = useMemo(() => {
    if (!businessLineOtherFeeList) return [];

    return businessLineOtherFeeList.map((item) => ({
      label: _.get(item, 'attributes.name'),
      value: _.get(item, 'id'),
    }));
  }, [businessLineOtherFeeList]);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    if (!validateForm.response.is_passed) {
      return false;
    }

    const args = {
      ...formData,
      ordinance_revision_id: ordinanceRevisionId,
      code: _.get(formData, 'code').toUpperCase(),
      other_fees: _.get(formData, 'other_fees', []).map((item) => +item.value),
    };

    return createNewBusinessLines(newBusinessNaturesId, args, () => {
      setModal({ isOpen: false });
      getNewBusinessLinesList(newBusinessNaturesId, {
        ordinance_revision_id: ordinanceRevisionId,
      });
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Code: {validateForm.renderMessage('code')}
            </label>
            <input
              className="form-control"
              type="text"
              name="code"
              onChange={handleOnChange}
              placeholder="Ex. CODE-1234"
              style={{ textTransform: 'uppercase' }}
              value={_.get(formData, 'code')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Name: {validateForm.renderMessage('name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="name"
              onChange={handleOnChange}
              value={_.get(formData, 'name')}
            />
          </div>
          <div className="col-6 form-group">
            <label>License Code</label>
            <License
              name="license_code"
              onChange={handleOnChange}
              ordinanceRevisionId={ordinanceRevisionId}
              value={_.get(formData, 'license_code') || ''}
            />
          </div>
          <div className="col-6 form-group">
            <label>Permit Code</label>
            <Permit
              name="permit_code"
              onChange={handleOnChange}
              ordinanceRevisionId={ordinanceRevisionId}
              value={_.get(formData, 'permit_code') || ''}
            />
          </div>
          <div className="col-6 form-group">
            <label>Sanitary Code</label>
            <Sanitary
              name="sanitary_code"
              onChange={handleOnChange}
              ordinanceRevisionId={ordinanceRevisionId}
              value={_.get(formData, 'sanitary_code') || ''}
            />
          </div>
          <div className="col-6 form-group">
            <label>Garbage Code</label>
            <Garbage
              name="garbage_code"
              onChange={handleOnChange}
              ordinanceRevisionId={ordinanceRevisionId}
              value={_.get(formData, 'garbage_code') || ''}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="other_fees" className="full-label mb-0">
              Other Fees:
            </label>
            <InputReactSelect
              name="other_fees"
              value={formData.other_fees}
              onChange={handleOnChange}
              options={otherFeesOptions}
              isMulti // Enable multi-select
              placeholder="Search and select other fees..."
              // formatOptionLabel={formatOptionLabel}
              additional={{
                closeMenuOnSelect: false, // Keep menu open after selection
                menuPlacement: 'auto',
                // Optional: limit maximum selections
                // isOptionDisabled: () => formData.users.length >= 5,
              }}
              isLoading={isOtherFeesLoading}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={creating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
          >
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateRangeModal.propTypes = {
  newBusinessNaturesId: PropTypes.string.isRequired,
  getNewBusinessLinesList: PropTypes.instanceOf(Function).isRequired,
  createNewBusinessLines: PropTypes.instanceOf(Function).isRequired,
  creating: PropTypes.bool.isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
  getBusinessLineOtherFeeList: PropTypes.instanceOf(Function).isRequired,
  businessLineOtherFeeList: PropTypes.instanceOf(Array).isRequired,
  isOtherFeesLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  creating: api.loading.indexOf(c.CREATE_NEW_BUSINESS_LINES) > -1,
  businessLineOtherFeeList: _.get(
    api,
    `${c.GET_BUSINESS_LINE_OTHER_FEES}.list`,
    []
  ),
  isOtherFeesLoading: api.loading.indexOf(c.GET_BUSINESS_LINE_OTHER_FEES) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateRangeModal);
